import { ApiUrls } from '../../Models/ApiUrls';
import { PromotionBandeauResponse } from '../../Models/Promos/PromotionBandeauDto';
import { ApiRequest } from '../XHR/ApiRequest';

export class PromosApi {
    public static getCurrentPromotionBandeau = (): Promise<PromotionBandeauResponse> => {
        return ApiRequest.get<PromotionBandeauResponse>(ApiUrls.GET_CURRENT_PROMOTION_BANDEAU);
    };
}
